export const PAYMENTS_API_ERROR_CODES = {
    WRONG_ZIP_CODE: 800_000,
} as const;
